"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var renderBlock = function renderBlock(block, contentState) {
  var blockText = block.getText();
  var currentEntity;
  var lastEntityEnd = 0;
  var res = '';
  block.findEntityRanges(function (c) {
    var entityKey = c.getEntity();

    if (entityKey !== null && contentState.getEntity(entityKey).getType() === 'PLACEHOLDER') {
      currentEntity = contentState.getEntity(entityKey).data.placeholder;
      return true;
    }

    return false;
  }, function (start, end) {
    res += "".concat(blockText.substring(lastEntityEnd, start)).concat(currentEntity);
    lastEntityEnd = end;
  }); // Add rest of the text after last entity or none...

  res += blockText.substring(lastEntityEnd, blockText.length);
  return res;
};

var _default = function _default(contentState) {
  return contentState.getBlocksAsArray().reduce(function (text, block) {
    return text + renderBlock(block, contentState);
  }, '');
};

exports["default"] = _default;